import { render, staticRenderFns } from "./AddPointsDialog.vue?vue&type=template&id=1b39bc28&scoped=true"
import script from "./AddPointsDialog.vue?vue&type=script&lang=js"
export * from "./AddPointsDialog.vue?vue&type=script&lang=js"
import style0 from "./AddPointsDialog.vue?vue&type=style&index=0&id=1b39bc28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b39bc28",
  null
  
)

export default component.exports